import { Close } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Skeleton,
  styled,
  useTheme,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

const StyledHeaderTitle = styled(DialogTitle)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: "#fff",
  position: "relative",
  "& button": {
    position: "absolute",
    right: "15px",
    top: "15px",
    color: "#fff",
  },
}));

const FlexContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  marginBottom: "10px",
  alignItems: "flex-start",
}));

const FlexInnerTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minWidth: "249px",
  maxWidth: "250px",
  fontWeight: "600",
}));

const Values = styled("div")(({ theme }) => ({
  marginLeft: "10px",
  fontWeight: "500",
  color: theme.palette.primary.dark,
}));

const AppBarTabs = styled(AppBar)(({ theme }) => ({
  background: "#fff",
  color: theme.palette.primary.dark,
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ViewDetails = (props) => {
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [dialogDetails, setDialogDetails] = useState({
    open: true,
  });

  useEffect(() => {
    props.sendDetails(dialogDetails);
  }, [props, dialogDetails]);

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  return (
    <div>
      <Dialog
        open={dialogDetails.open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <StyledHeaderTitle id="alert-dialog-title">
          <div>
            View In Master Details {"(" + (props.viewDetails.ID || "-") + ")"}
          </div>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </StyledHeaderTitle>
        {props.singleLoading ? (
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box p={3} sx={{ width: "100%" }}>
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={3} sx={{ width: "100%" }}>
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                  <Skeleton height={40} />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
        ) : (
          <DialogContent sx={{ padding: "0" }}>
            <AppBarTabs position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="inherit"
                variant="fullWidth"
                aria-label="full width tabs example"
              >
                <Tab label="In Master Details" {...a11yProps(0)} />
              </Tabs>
            </AppBarTabs>

            <TabPanel value={value} index={0} dir={theme.direction}>
              <Box>
                <Grid container>
                  <Grid item xs={12} md={6}>
                    <FlexContent>
                      <FlexInnerTitle>
                        <span>ID</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.ID || "-"}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Code</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.CODE}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Category</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.CATEGORY}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Stock Cat#</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails["STOCKCAT#"]}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Tax Rate</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.TAXRATE}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Unit</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.UNIT}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Volume</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.VOLUME}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Price/Unit</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.PRICE_UNIT}</Values>
                    </FlexContent>
                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Make</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.MAKE}</Values>
                    </FlexContent>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Vendor</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.VENDOR}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Vendors Code</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.VENDORS_CODE}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Qty On Hand</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.QTY_ONHAND}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Qty Backdrop</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.QTY_BACKORD}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Qty On Ord</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.QTY_ONORD}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Qty Sold</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.QTY_SOLD}</Values>
                    </FlexContent>
                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Qty Purch</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.QTY_PURCH}</Values>
                    </FlexContent>
                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Description</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.DESCRIPTION}</Values>
                    </FlexContent>

                    <FlexContent>
                      <FlexInnerTitle>
                        <span>Created Date</span> <span> : </span>
                      </FlexInnerTitle>
                      <Values>{props.viewDetails.CREATE_DATE}</Values>
                    </FlexContent>
                  </Grid>
                </Grid>
              </Box>
            </TabPanel>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ViewDetails;
